import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class ProductChargeService {
  private baseApiUrl: string;
 

  constructor(configurationService: ConfigurationService,
    private httpClient: HttpClient 
  ) {
    this.baseApiUrl = configurationService.BaseApiUrl;
   
  }

  
 
  getFiltered(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = true): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };
    

    return this.httpClient.post(this.baseApiUrl + 'charge/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getAll(forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `charge/{id}?isMaintenance=${forMaintenance}`).pipe(
     map((res: any) =>  res),
     catchError((err: any) => observableThrowError(err.message || 'Server error')));
 }

  getById(id: number, forMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `charge/${id}?isMaintenance=${forMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createCharges(selectedResult: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'charge', selectedResult).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  update(selectedResult: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'charge', selectedResult).pipe(
    map((res: Response) => res),
    catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'charge/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `charge/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

 

}
